import { useState } from 'react';
import NavigationCard from '../../components/card/navigation-card/navigation-card.component';
import { FileText, Plus } from 'react-feather';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ReactComponent as Contact } from '../../assets/images/card-icons/contact.svg';
import CreateCollection from '../daily-fee/CreateCollection';
import { ConfirmModal } from '../../components/modal/confirm-modal/ConfirmModal.component';
import { useNewBadge } from '../../utils/useNewBadge';
import { useCustomMutation } from '../../utils/useCustomMutation';
import { postMethod } from '../../api/common';
import { Checkbox, Link } from 'carbon-components-react';
import DailyFeeTermsModal from './DailyFeeTermsModal';
import { useCurrentUser, useIsAllowed } from '../../utils/useCurrentUser';
import { isAdmin } from '../../utils/common.util';

export function DailyBillingFeesCard() {
  const [isOpen, setIsOpen] = useState('');

  const { isAllowed } = useIsAllowed();

  const { user, isLoadingUser } = useCurrentUser();

  const history = useHistory();

  const isDailyFeeAccess = isAllowed([
    'DailyBillingFeesAccess',
    'DailyBillingFeesAccessReadOnly',
  ]);

  function checkAccess(routine, condition = !isDailyFeeAccess) {
    if (user?.school?.dailyBillingSubscription?.id && isDailyFeeAccess) {
      routine();
    } else {
      setIsOpen(condition ? 'not-allowed' : 'subscribe');
    }
  }

  const { trigger, isMutating, error } = useCustomMutation(
    `daily-billing/create-subscription`,
    (url, { arg }) => postMethod(url, arg),
  );

  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [recordDailyBillingInLedger, setRecordDailyBillingInLedger] =
    useState(false);

  const showNewBadge = useNewBadge('2025-07-28', 12);

  const is_fee_type = isAllowed([
    'DailyBillingFeesTypeCreationAccess',
    'DailyBillingFeesTypeCreationAccessReadOnly',
  ]);

  // if you're not an admin and you don't have access to the module, don't show the card
  if (!isAdmin() && !isDailyFeeAccess) {
    return null;
  }

  return (
    <>
      <div className="bx--col-md-2 fade-in">
        <NavigationCard
          isLoading={isLoadingUser}
          isNew={showNewBadge}
          title="Daily Fee Collection"
          linkIcon1={<Plus size="13" className="link-icon" />}
          linkText1={'COLLECT FEES'}
          linkAction1={() => checkAccess(() => setIsOpen('collect'))}
          linkIcon2={
            is_fee_type && <FileText size="12" className="link-icon" />
          }
          linkText2={is_fee_type && 'FEE TYPES'}
          linkAction2={() =>
            checkAccess(() => history.push('/daily-fees/types'), !is_fee_type)
          }
          btnText="VIEW"
          btnAction={() => checkAccess(() => history.push('/daily-fees'))}
        >
          <Contact />
        </NavigationCard>
      </div>

      <ConfirmModal
        title="ACCESS DENIED!"
        isOpen={isOpen === 'not-allowed'}
        closeModal={() => setIsOpen('')}
        secondaryActionText="Close"
        description={
          <>
            <p className="text-label">
              You do not have the permission to access to this module. Contact
              an administrator for assistance.
            </p>
          </>
        }
      />

      <ConfirmModal
        title="Subscribe to Daily Fees Module"
        isOpen={isOpen === 'subscribe'}
        closeModal={() => setIsOpen('')}
        description={
          <>
            <p className="text-label">
              To access the Daily Fees Module, please subscribe to the module.
              The cost of this subscription will be added to your invoice.
            </p>

            <Checkbox
              id="recordDailyBillingInLedger"
              name="recordDailyBillingInLedger"
              labelText="Record Daily Fee Billing in Ledger"
              className="mt-30"
              checked={recordDailyBillingInLedger}
              onChange={(value) => setRecordDailyBillingInLedger(value)}
            />

            <div className="mt-20">
              <Checkbox
                id="termsAndConditions"
                name="termsAndConditions"
                labelText="I agree to the terms and conditions for this subscription."
                checked={agreeToTerms}
                onChange={(value) => setAgreeToTerms(value)}
              />

              <Link
                onClick={() => setIsOpen('terms')}
                style={{ fontSize: '12px' }}
                className="mt-20 text-primary pointer"
              >
                Terms and conditions
              </Link>
            </div>
          </>
        }
        actionText="SUBSCRIBE"
        onClick={() =>
          trigger(
            { recordDailyBillingInLedger },
            { onSuccess: () => history.push('/daily-fees') },
          )
        }
        disabled={!agreeToTerms}
        isLoading={isMutating}
        errorMessage={error ? error.message : null}
        actionBtnClasses="primary"
      />

      <DailyFeeTermsModal
        isOpen={isOpen === 'terms'}
        closeModal={() => setIsOpen('subscribe')}
      />

      <CreateCollection
        isOpen={isOpen === 'collect'}
        closeModal={() => setIsOpen('')}
      />
    </>
  );
}
